import { useMemo } from 'react';
import { useListCreatableSpacesQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/SpaceEligibilityRpc.hooks';
import { buildCreatableSpaces } from '../utils/creatableSpaces';
import { getPortalAccountId, getPortalDomain, getPortalInstanceId } from '../utils/metadata';
// Returns the space types the authenticated contact is allowed to create. The
// backend only returns entries for eligible callers (HubSpot users), so an empty
// list is the signal that the current contact cannot create spaces. Pass
// `skip` to avoid firing the RPC for visitors who can never create a space
// (e.g. the gate is off or the identity is not a HubSpot user).
export function useCreatableSpaces(options) {
  var _getPortalDomain;
  const {
    data,
    loading
  } = useListCreatableSpacesQuery({
    skip: options === null || options === void 0 ? void 0 : options.skip,
    variables: {
      // Portal apps run on the customer's own domain, so the backend keys
      // eligibility off the portal domain injected by the theme
      // (x-hs-portals-domain-override). Fall back to the live hostname if the
      // meta tag is ever missing.
      domain: (_getPortalDomain = getPortalDomain()) !== null && _getPortalDomain !== void 0 ? _getPortalDomain : window.location.hostname,
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
      tolerateInstanceAccessDenied: true
    }
  });
  return useMemo(() => buildCreatableSpaces({
    data,
    loading
  }), [data, loading]);
}